module.exports = __webpack_public_path__ + "img/ali.71c08d13.png";